import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { EyeEmpty, EyeOff } from "iconoir-react";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import telecommunications from "../../../assets/telecommunications.png";
import logoGuentic from "../../../assets/logoGuentic.png";
import logonew2 from "../../../assets/logonew2.webp";
import { Loader } from "../../../Loader/Loader";
import { domain } from "../../../Urls/Services/Api_urls";
import Navbar from "../../../Gerneralcomponents/Navbar/Navbar";
import Footer from "../../../Gerneralcomponents/Footer/footer";
import "../AceptarAgregarServicio/ConfirmAddNewService.css";

const TYPE_ENDPOINT = {
  corporateClientLink: (token) => `/user/${token}/corporateClientLink/`,
  unifiedSaleEmpresarial: (token) => `/user/${token}/unifiedSaleEmpresarial/`,
};

const extractMessage = (respuesta, fallback) => {
  if (typeof respuesta?.message === "string") return respuesta.message;
  if (typeof respuesta?.msg === "string") return respuesta.msg;
  return fallback;
};

export default function ConfirmEmpresarial() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [type, setType] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const ctaRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setToken(params.get("token") || "");
    setType(params.get("type") || "");
  }, [location.search]);

  useEffect(() => {
    ctaRef.current?.focus();
  }, [type]);

  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleConfirmarVinculacion = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${domain}${TYPE_ENDPOINT.corporateClientLink(token)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        }
      );
      const respuesta = await response.json().catch(() => null);
      setLoading(false);
      if (response.ok) {
        await Swal.fire({
          title: "¡Vinculación confirmada!",
          text: extractMessage(
            respuesta,
            "Tu contrato empresarial quedó vinculado a la cuenta."
          ),
          icon: "success",
          confirmButtonText: "Ir al inicio",
          allowOutsideClick: false,
        });
        navigate("/Login", { state: { from: "/Empresarial" } });
      } else {
        await Swal.fire({
          title: "No se pudo confirmar",
          text: extractMessage(
            respuesta,
            "Intenta nuevamente o contacta a soporte."
          ),
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    } catch (error) {
      setLoading(false);
      await Swal.fire({
        title: "Error al confirmar",
        text: "Intenta nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const handleAsignarContrasena = async (e) => {
    e.preventDefault();
    if (!password || !password2) {
      Swal.fire({
        icon: "warning",
        title: "Completa ambos campos de contraseña",
      });
      return;
    }
    if (password !== password2) {
      Swal.fire({
        icon: "error",
        title: "Las contraseñas no son iguales",
        text: "Revisa tus contraseñas!",
      });
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${domain}${TYPE_ENDPOINT.unifiedSaleEmpresarial(token)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, password, password2 }),
        }
      );
      const respuesta = await response.json().catch(() => null);
      setLoading(false);
      if (response.ok) {
        await Swal.fire({
          title: "¡Perfecto!",
          text: extractMessage(
            respuesta,
            "Se asignó la contraseña exitosamente."
          ),
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });
        navigate("/Login", { state: { from: "/Empresarial" } });
      } else {
        Swal.fire({
          title: "No se pudo asignar la contraseña",
          text: extractMessage(respuesta, "Intenta nuevamente."),
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text: "Hubo un error!",
        icon: "error",
        confirmButtonText: "Intentar",
      });
    }
  };

  const renderContent = () => {
    if (!token || !type) {
      return (
        <>
          <h2 className="title-greeting">Enlace inválido</h2>
          <p className="lead">
            El enlace al que ingresaste no incluye la información necesaria
            para continuar. Verifica el correo o solicita uno nuevo.
          </p>
        </>
      );
    }

    if (type === "corporateClientLink") {
      return (
        <>
          <h2 className="title-greeting">Confirma tu vinculación</h2>
          <p className="lead">
            Tu contrato empresarial está listo para vincularse a esta
            cuenta.
            <br />
            Haz clic en <b>&quot;Aceptar&quot;</b> para confirmar.
          </p>
          <button
            ref={ctaRef}
            className="cta"
            onClick={handleConfirmarVinculacion}
            disabled={loading}
            aria-busy={loading ? "true" : "false"}
            aria-label="Aceptar y confirmar la vinculación"
          >
            Aceptar
          </button>
        </>
      );
    }

    if (type === "unifiedSaleEmpresarial") {
      return (
        <>
          <h2 className="title-greeting">Activa tu cuenta</h2>
          <p className="lead">
            Crea la contraseña con la que ingresarás a tu cuenta
            empresarial.
          </p>
          <form
            onSubmit={handleAsignarContrasena}
            style={{ width: "100%", maxWidth: 360 }}
          >
            <FormControl fullWidth>
              <InputLabel htmlFor="empresarial-password">
                Contraseña*
              </InputLabel>
              <Input
                id="empresarial-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                variant="standard"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword((show) => !show)}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <EyeOff /> : <EyeEmpty />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <div style={{ height: 20 }} />
            <FormControl fullWidth>
              <InputLabel htmlFor="empresarial-password2">
                Confirmar Contraseña*
              </InputLabel>
              <Input
                id="empresarial-password2"
                type={showPassword2 ? "text" : "password"}
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                required
                variant="standard"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword2((show) => !show)}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword2 ? <EyeOff /> : <EyeEmpty />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <button
              ref={ctaRef}
              className="cta"
              type="submit"
              disabled={loading}
              style={{ marginTop: 24, width: "100%" }}
            >
              Confirmar
            </button>
          </form>
        </>
      );
    }

    return (
      <>
        <h2 className="title-greeting">Tipo de solicitud no reconocido</h2>
        <p className="lead">
          No pudimos identificar la acción a realizar. Contacta a soporte.
        </p>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="confirm-add-service-wrapper">
        {loading && (
          <div className="blocking-loader">
            <Loader />
            <span className="sr-only" aria-live="polite">
              Procesando solicitud…
            </span>
          </div>
        )}
        <main className="page" role="main" aria-label="Confirmación empresarial">
          <section
            className="hero"
            aria-hidden="true"
            style={{
              backgroundImage: `linear-gradient(120deg, rgba(16,14,32,.65), rgba(9,12,26,.15)), url(${telecommunications})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          <section className="panel">
            <div className="panel-card">
              <img src={logonew2} alt="Logo EMCALI" className="brand" />
              {renderContent()}
            </div>
            <img src={logoGuentic} alt="Guentic" className="corner" />
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
}
